import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { t } from 'ttag';

import Button from '../ui/button/button';
import Checkbox from '../ui/checkbox/checkbox';
import Input from '../ui/input/input';
import PseudoLink from '../ui/pseudolink/pseudolink';
import Title from '../ui/title/title';

import { trackForm } from '../../services/analytics/formTracking';
import PageTitle from '../pageTitle/pageTitle';

import css from './verify2FA.css';

/**
 *
 * @deprecated
 * @see `cs/components/verify2FA/new/NewVerify2FA.tsx`
 */
class Verify2FA extends Component {
    static propTypes = {
        code: PropTypes.string,
        errorMessage: PropTypes.string,
        onChangeCode: PropTypes.func.isRequired,
        onResendCode: PropTypes.func.isRequired,
        onSubmitCode: PropTypes.func.isRequired,
        onToggleTrusted: PropTypes.func.isRequired,
        secondsLeft: PropTypes.number,
        status: PropTypes.bool,
        trusted: PropTypes.bool,
        isErrorResend: PropTypes.bool,
    };

    componentDidMount() {
        this.formTracker = trackForm(this.form, '2fa_verify');
    }

    componentWillUnmount() {
        this.formTracker.onFormClose();
    }

    handleChangeCode = (evt) => {
        this.props.onChangeCode(evt.target.value);
    };

    handleSubmitCode = (evt) => {
        evt.preventDefault();
        this.formTracker.submitTry();
        this.props.onSubmitCode(this.formTracker);
    };

    handleResend = () => {
        this.props.onResendCode();
    };

    renderActions() {
        if (this.props.secondsLeft) {
            if (this.props.isErrorResend) {
                const isSecondsLeftMoreMinute =
                    !!this.props.secondsLeft && this.props.secondsLeft > 60;
                const isErrorResendText = isSecondsLeftMoreMinute
                    ? t`Ви надіслали забагато запитів на отримання коду. Повторіть спробу за годину.`
                    : t`Не отримали повідомлення? Наступна відправка можлива через ${this.props.secondsLeft} с.`;

                return <div className={css.cell}>{isErrorResendText}</div>;
            }
            return (
                <div>
                    <p className={css.success}>
                        {t`Повідомлення з кодом було надіслано повторно.`}
                    </p>
                    <p>
                        {t`Все рівно не отримали повідомлення? Зачекайте`}{' '}
                        {this.props.secondsLeft} {t`с.`}
                    </p>
                </div>
            );
        }
        return (
            <div className={css.cell}>
                {t`Не отримали повідомлення?`}{' '}
                <PseudoLink onClick={this.handleResend}>
                    {t`Надіслати повторно`}
                </PseudoLink>
            </div>
        );
    }

    render() {
        return (
            <form
                className={css.root}
                onSubmit={this.handleSubmitCode}
                ref={(el) => {
                    this.form = el;
                }}
            >
                <PageTitle>{t`Двофакторна авторизація`}</PageTitle>
                <Title>{t`Вкажіть код підтвердження з повідомлення`}</Title>
                <p className={css.hint}>
                    {t`Що було надіслано на номер телефону, вказаний у вашому
                    профайлі`}
                </p>

                <div className={css.form}>
                    <div className={css.row}>
                        <div className={css.label}>
                            <label htmlFor="code">{t`Код підтвердження`}</label>
                        </div>
                        <div className={css.cell}>
                            <Input
                                autoComplete="off"
                                autoFocus
                                error={Boolean(this.props.errorMessage)}
                                errorMessage={this.props.errorMessage}
                                id="code"
                                name="code"
                                onChange={this.handleChangeCode}
                                type="text"
                                value={this.props.code}
                            />
                        </div>
                    </div>
                    <div className={css.row}>
                        <div className={css.label}>
                            <label htmlFor="code" />
                        </div>
                        <div className={css.cell}>
                            <Checkbox
                                sizeBig
                                name="trusted"
                                checked={this.props.trusted}
                                onChange={this.props.onToggleTrusted}
                                text={t`
                                  Це надійний пристрій.
                                  Підтверджувати себе за кодом СМС/Viber раз на місяць.
                                `}
                            />
                        </div>
                    </div>
                    <div className={css.row}>
                        <div className={css.label} />
                        <div className={css.cell}>
                            <Button
                                isLoading={this.props.status === null}
                                theme="cta"
                                type="submit"
                                width="full"
                            >
                                {t`Підтвердити`}
                            </Button>
                        </div>
                    </div>
                    <div className={css.row}>
                        <div className={css.label} />
                        {this.renderActions()}
                    </div>
                </div>
            </form>
        );
    }
}

export default Verify2FA;
